import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ShopLayout from '../../components/shop/ShopLayout';
import { useAuth } from '../../context/AuthContext';
import './AuthForm.css';
import Seo from '../../components/seo/Seo';

function RegisterPage() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    company: '',
    password: '',
    confirm_password: '',
    newsletter: false,
    terms_accepted: false
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const update = (field, value) => setForm((f) => ({ ...f, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirm_password) {
      setError('Passwords do not match');
      return;
    }
    if (!form.terms_accepted) {
      setError('You must accept the terms and conditions');
      return;
    }
    setLoading(true);
    try {
      await register(form);
      navigate('/account');
    } catch (err) {
      setError(err.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ShopLayout breadcrumbs={[{ label: 'Register' }]}>
      <Seo title="Create Account" path="/register" />
      <div className="container auth-page">
        <div className="auth-card auth-card--wide">
          <h1>Create Account</h1>
          <p className="auth-card__subtitle">Register to track orders and save addresses for faster checkout.</p>
          <form className="auth-form" onSubmit={handleSubmit}>
            {error && <div className="auth-form__error">{error}</div>}
            <div className="auth-form__row">
              <div className="auth-form__field">
                <label htmlFor="first_name">First Name *</label>
                <input id="first_name" required value={form.first_name} onChange={(e) => update('first_name', e.target.value)} />
              </div>
              <div className="auth-form__field">
                <label htmlFor="last_name">Last Name *</label>
                <input id="last_name" required value={form.last_name} onChange={(e) => update('last_name', e.target.value)} />
              </div>
            </div>
            <div className="auth-form__field">
              <label htmlFor="email">Email *</label>
              <input id="email" type="email" required value={form.email} onChange={(e) => update('email', e.target.value)} />
            </div>
            <div className="auth-form__row">
              <div className="auth-form__field">
                <label htmlFor="phone">Phone</label>
                <input id="phone" type="tel" value={form.phone} onChange={(e) => update('phone', e.target.value)} />
              </div>
              <div className="auth-form__field">
                <label htmlFor="company">Company</label>
                <input id="company" value={form.company} onChange={(e) => update('company', e.target.value)} />
              </div>
            </div>
            <div className="auth-form__row">
              <div className="auth-form__field">
                <label htmlFor="password">Password *</label>
                <input id="password" type="password" required minLength={8} value={form.password} onChange={(e) => update('password', e.target.value)} />
              </div>
              <div className="auth-form__field">
                <label htmlFor="confirm_password">Confirm Password *</label>
                <input id="confirm_password" type="password" required value={form.confirm_password} onChange={(e) => update('confirm_password', e.target.value)} />
              </div>
            </div>
            <label className="auth-form__checkbox">
              <input type="checkbox" checked={form.newsletter} onChange={(e) => update('newsletter', e.target.checked)} />
              Subscribe to newsletter for product updates and offers
            </label>
            <label className="auth-form__checkbox">
              <input type="checkbox" checked={form.terms_accepted} onChange={(e) => update('terms_accepted', e.target.checked)} />
              I agree to the Terms & Conditions and Privacy Policy *
            </label>
            <button type="submit" className="auth-form__submit" disabled={loading}>
              {loading ? 'Creating account…' : 'Create Account'}
            </button>
          </form>
          <div className="auth-card__footer">
            <p>Already have an account? <Link to="/login">Sign in</Link></p>
          </div>
        </div>
      </div>
    </ShopLayout>
  );
}

export default RegisterPage;
